import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

interface CheckboxProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

const CheckboxContainer = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const StyledCheckbox = styled.div<{ checked: boolean; disabled: boolean }>`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ disabled }) => (disabled ? '#999' : '#333')};
  border-radius: 4px;
  background-color: ${({ checked, disabled }) => 
    disabled ? (checked ? '#999' : '#ccc') : checked ? '#333' : 'transparent'};
  transition: all 0.2s;

  &::after {
    content: '';
    position: absolute;
    display: ${({ checked }) => (checked ? 'block' : 'none')};
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const Label = styled.label<{ disabled: boolean }>`
  margin-left: 8px;
  font-size: 16px;
  color: ${({ disabled }) => (disabled ? '#999' : '#333')};
`;

export const Checkbox: React.FC<CheckboxProps> = ({ label, checked = false, onChange, disabled = false }) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(()=>{
    setIsChecked(checked)
  },[checked])

  const handleCheckboxChange = () => {
    if (disabled) return; // Impede a alteração do estado se estiver desabilitado
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <CheckboxContainer onClick={handleCheckboxChange} disabled={disabled}>
      <HiddenCheckbox checked={isChecked} onChange={handleCheckboxChange} disabled={disabled} />
      <StyledCheckbox checked={isChecked} disabled={disabled} />
      <Label disabled={disabled}>{label}</Label>
    </CheckboxContainer>
  );
};